<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? 'Update task' : 'Add new task'" subtitle="Create a task for yourself or someone else here." class="py-8 border-b">
              <div class="col-span-12 md:col-span-8">
                <ui-input label="Title" name="name" :error="form.errors.get('name')" v-model="form.name"></ui-input>
              </div>
              <div class="col-span-12 md:col-span-4">
                <ui-date-picker label="Due" name="due" :error="form.errors.get('due')" v-model="form.due"></ui-date-picker>
              </div>
              <ui-textarea label="Description" name="description" :error="form.errors.get('description')" v-model="form.description"></ui-textarea>
              <ui-select-searchable
                  class="col-span-12"
                  label="Assign To"
                  multiple
                  v-model="form.assignees"
                  :error="form.errors.get('assignee_ids')"
                  :search="searchUser"
              ></ui-select-searchable>
              <ui-select-searchable
                  class="col-span-12"
                  label="Related Package"
                  v-model="form.package"
                  :error="form.errors.get('package')"
                  :search="searchPackage"
              ></ui-select-searchable>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import { User, Package, Task } from '@models'

export default {
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {}

        return {
            form: new Form(initialData, async (form) => {
                if (this.editMode) {
                    await this.item.update(form.export())
                    this.edit(false)
                } else {
                    const task = await Task.create(form.export())
                    this.addItem(task, 0)

                    form.reset()
                }
            }),
        }
    },
    methods: {
        async searchUser (query) {
            return (await User.search(query)).map(x => x.toDropdown())
        },
        async searchPackage (query) {
            return (await Package.search(query)).map(x => x.toDropdown())
        }
    },
    computed: {
        editMode () {
            return !! this.item
        },
    },
}
</script>
